import { createFileRoute } from '@tanstack/react-router'

/** A lista vive no layout pathless `_receber`. Esta rota dá a URL /recebimentos/receber. */
export const Route = createFileRoute('/_authed/recebimentos/_receber/receber')({
  component: () => null,
})
